module.exports = __webpack_public_path__ + "static/media/01.29dfe51e.png";